import { useEffect, useState } from "react";
import { apiBase } from "@/lib/api";

export type LiveAlert = {
  id: number;
  kind: string;
  forum_id?: number;
  thread_id?: number;
  post_id?: number;
  at: string;
};

export function useAlertsStream(appUserId: number) {
  const [last, setLast] = useState<LiveAlert | null>(null);

  useEffect(() => {
    if (!appUserId) return;
    // The stream identifies the user from the auth cookie (the api-ts proxy
    // injects X-User-Id towards the Go API). No client-supplied id.
    const url = `${apiBase}/api/alerts/stream`;
    const es = new EventSource(url, { withCredentials: true });
    es.addEventListener("alert", (e) => {
      try {
        setLast(JSON.parse((e as MessageEvent).data));
      } catch {
        // ignore
      }
    });
    es.onerror = () => {
      // browser EventSource auto-reconnects
    };
    return () => es.close();
  }, [appUserId]);

  return last;
}
